import React from "react";
import { Popover } from "@mui/material";
import styles from "./index.module.css";
import moment from "moment";

const OrderBreakdown = ({
  anchorEl,
  onClose,
  order,
  isSelfCheckout,
  isFlex,
}) => {
  const open = Boolean(anchorEl);

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      slotProps={{
        paper: {
          className: styles?.popoverPaper,
        },
      }}
    >
      <div className={styles?.breakdownContainer}>
        {!isSelfCheckout &&
          order?.map((childOrder, index) => (
            <div key={index} className={styles?.childBlock}>
              <p className={styles?.childTitle}>{childOrder?.studentName}</p>

              {childOrder?.coursesInfo?.map((course, i) => (
                <div key={i} className={styles?.subjectRow}>
                  <p className={styles?.subjectName}>
                    {`${course?.courseName}${course?.isFlex ? "" : ` - ${course?.credits} credits`}`}
                  </p>

                  {!isFlex && (
                    <p className={styles?.expiry}>
                      Expiry:{" "}
                      {course?.expiryDate
                        ? moment(course?.expiryDate).format("DD MMM YYYY")
                        : ""}
                    </p>
                  )}
                </div>
              ))}
            </div>
          ))}
      </div>
    </Popover>
  );
};

export default OrderBreakdown;
